import classNames from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import styled, { type CSSProperties } from 'styled-components';

import { absCenter } from '@sorare/core/src/lib/style';

export enum WrapperType {
  PRIMARY,
  SECONDARY,
}

const Root = styled.div`
  position: relative;
  border-radius: var(--double-unit);
  padding: var(--triple-unit) var(--double-unit) var(--double-unit)
    var(--double-unit);
  border: 1px solid transparent;
  box-shadow: inset 0px 50px 50px -50px rgba(var(--rgb-color), 0.08);
`;

const PrimaryRoot = styled(Root)`
  border: 1px solid transparent;
  background:
    radial-gradient(
        ellipse 50% 8px at top,
        rgba(var(--rgb-color), 0.5) 20%,
        transparent 100%
      )
      no-repeat,
    linear-gradient(to bottom, transparent, var(--c-black)) padding-box,
    conic-gradient(from 90deg at 4px 4px, var(--c-nd-50) 25%, var(--c-black) 0)
      0 0/5px 5px padding-box,
    linear-gradient(
        to bottom,
        rgba(var(--rgb-color), 0.08),
        rgba(var(--rgb-color), 0)
      )
      border-box,
    linear-gradient(to bottom, var(--c-nd-100-opaque), var(--c-nd-100-opaque))
      padding-box,
    linear-gradient(
        to bottom,
        rgba(var(--rgb-color), 0.3),
        rgba(var(--rgb-color), 0) 70%
      )
      border-box;
`;
const SecondaryRoot = styled(Root)`
  background:
    linear-gradient(to bottom, var(--c-nl-500), var(--c-nl-500)) padding-box,
    linear-gradient(to bottom, transparent, rgba(var(--rgb-color), 0.08))
      padding-box,
    conic-gradient(from 90deg at 4px 4px, var(--c-nd-50) 25%, var(--c-black) 0)
      0 0/5px 5px padding-box,
    linear-gradient(
        to bottom,
        rgba(var(--rgb-color), 0.2),
        rgba(var(--rgb-color), 0.8)
      )
      border-box;

  &.disabled {
    filter: grayscale(1) brightness(0.6);
  }
`;
const Header = styled.div`
  ${absCenter}
  top: 0px;
`;

type Props = {
  type: WrapperType;
  rgbColor?: string;
  header?: ReactNode;
  disabled?: boolean;
};
export const RewardWrapper = ({
  type,
  rgbColor,
  header,
  children,
  disabled,
}: PropsWithChildren<Props>) => {
  if (type === WrapperType.SECONDARY) {
    return (
      <SecondaryRoot
        className={classNames({ disabled })}
        style={{ '--rgb-color': rgbColor } as CSSProperties}
      >
        <Header>{header}</Header>
        {children}
      </SecondaryRoot>
    );
  }

  return (
    <PrimaryRoot
      className={classNames({ disabled })}
      style={{ '--rgb-color': rgbColor } as CSSProperties}
    >
      <Header>{header}</Header>
      {children}
    </PrimaryRoot>
  );
};
